/** A tiny bus between the API module (which queues) and the screen state (which shows the queue), so neither imports the other. */

const queued = new Set<() => void>();

export const onQueued = (fn: () => void): (() => void) => {
  queued.add(fn);
  return () => queued.delete(fn);
};

export const emitQueued = (): void => queued.forEach((fn) => fn());
